/* eslint-disable no-param-reassign, max-params, max-lines */
import { useDtfStore } from "components/jiffy/vue-product-details-dtf/store";
import { SURFACES } from "../misc/constants";

const initialState = {};

const placementEnhancements = (dtfStore, currency) =>
  Object.values(dtfStore.summary.enhancements || {}).map(tier => ({
    isEnhancement: true,
    catalogNumber: tier.serviceName,
    price: `${currency}${Number(tier.totalPrice).toFixed(2)}`,
    quantity: tier.quantity
  }));

const checkoutModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    checkoutPayload: (state, getters, rootState, rootGetters) => {
      const dtfStore = useDtfStore();

      const placements = [];

      const frontArtwork = rootGetters["artwork_front/serializedArtwork"];
      if (frontArtwork) {
        placements.push({
          ...frontArtwork,
          width: rootGetters["surface_front/convertPxToInches"](frontArtwork.width),
          height: rootGetters["surface_front/convertPxToInches"](frontArtwork.height),
          position: rootGetters["surface_front/surfaceLabel"],
          custom_neck_distances: rootGetters["surface_front/serializedNeckLines"](
            frontArtwork.height
          ),
          preview: rootGetters["surface_front/getPreview"] || ""
        });
      }

      const backArtwork = rootGetters["artwork_back/serializedArtwork"];
      if (backArtwork) {
        placements.push({
          ...backArtwork,
          width: rootGetters["surface_back/convertPxToInches"](backArtwork.width),
          height: rootGetters["surface_back/convertPxToInches"](backArtwork.height),
          position: rootGetters["surface_back/surfaceLabel"],
          custom_neck_distances: rootGetters["surface_back/serializedNeckLines"](
            backArtwork.height
          ),
          preview: rootGetters["surface_back/getPreview"] || ""
        });
      }

      const currency = dtfStore.locale === "en-CA" ? "C$" : "$";

      if (placements.length > 0) {
        placements.push(...placementEnhancements(dtfStore, currency));
      }

      return placements;
    }
  },

  mutations: {},

  actions: {
    async resetPayload({ dispatch, rootGetters, commit }) {
      if (rootGetters["artwork_front/artworkExists"]) {
        dispatch("artwork_front/removeArtwork", null, { root: true });
        dispatch("surface_front/clearNeckLines", null, { root: true });
        commit("surface_front/setSurfaceLabel", SURFACES.FRONT, { root: true });
      }
      if (rootGetters["artwork_back/artworkExists"]) {
        dispatch("artwork_back/removeArtwork", null, { root: true });
        dispatch("artwork_back/clearNeckLines", null, { root: true });
        commit("surface_back/setSurfaceLabel", SURFACES.BACK, { root: true });
      }
    }
  }
};

export default checkoutModule;
